import Flickity from 'flickity'

export default () => {
    mainSlider()
    imageSlider()
}

export function mainSlider () {
    let slider = document.querySelector('body .flickity-slider')
    let left = document.querySelector('body .references .flickity-button-left')
    let right = document.querySelector('body .references .flickity-button-right')

    let options = {
        cellSelector: '.slide',
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true,
        autoPlay: false,
        wrapAround: true,
        groupCells: false,
        draggable: false,
        watchCSS: false
    }

    left.addEventListener( 'click', function() {
        flkty.previous()
    });
    right.addEventListener( 'click', function() {
        flkty.next()
    });

    if ( matchMedia('screen and (max-width: 1023px)').matches ) {
        options.draggable = true;
    }

    if ( matchMedia('screen and (min-width: 1024px)').matches ) {
        options.draggable = false;
    }

    var flkty = new Flickity (slider, options)

    window.addEventListener('load', function(event) {
        flkty.resize();
    });

    window.addEventListener('resize', function(event) {
        flkty.resize();
    });




}

export function imageSlider () {
    let slider = document.querySelectorAll('body .flickity-slider .slide .flex .image-slider')

    slider.forEach(function (slider) {
        let wrapper = slider
        let duration = 5;
        let interval = 10;
        let options = {
            cellSelector: '.image',
            pageDots: false,
            prevNextButtons: false,
            adaptiveHeight: false,
            autoPlay: false,
            wrapAround: true,
            groupCells: false,
            draggable: '>1',
            watchCSS: false
        }

        let imageLeft = slider.querySelector('.image-flickity-button-left')
        let imageRight = slider.querySelector('.image-flickity-button-right')

        if (imageLeft) {
            imageLeft.addEventListener( 'click', function() {
                flkty.previous()
            });
        }

        if (imageRight) {
            imageRight.addEventListener('click', function () {
                flkty.next()
            });
        }

        if ( matchMedia('screen and (max-width: 1023px)').matches ) {
            options.draggable = false;
        }

        if ( matchMedia('screen and (min-width: 1024px)').matches ) {
            options.draggable = '>1';
        }

        let flkty = new Flickity (slider, options)
        let progressBar = slider.querySelector('.progress .bar')
        window.addEventListener('load', function(event) {
            flkty.resize();
        });

        window.addEventListener('resize', function(event) {
            flkty.resize();
        });

        let isPaused = false;

        wrapper.addEventListener('mouseenter', function() {
            isPaused = true;
        });

        wrapper.addEventListener('mouseleave', function() {
            isPaused = false;
        });

        var percentTime,
            step,
            tick;

        function startProgressbar() {
            resetProgressbar();
            percentTime = 0;
            tick = window.setInterval(increase, interval);
        }

        function increase() {
            if (!isPaused) {
                step = (duration * 1000) / interval;
                percentTime += 100 / step;
                progressBar.style.width = percentTime + "%";
                if (percentTime >= 100) {
                    flkty.next();
                    startProgressbar();
                }
            }
        }

        function resetProgressbar() {
            progressBar.style.width = 0 + '%';
            clearTimeout(tick);
        }
        startProgressbar();
    });
}
